
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lightbulb } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { useState, useEffect } from "react";

const TipOfTheDay = () => {
  const { language } = useLanguage();
  const [animation, setAnimation] = useState(true);
  
  // Reset animation when language changes to create a refresh effect
  useEffect(() => {
    setAnimation(false);
    const timer = setTimeout(() => setAnimation(true), 100);
    return () => clearTimeout(timer);
  }, [language]);
  
  const getTodaysTip = () => {
    const day = new Date().getDate();
    const tipIndex = day % 3 + 1;
    
    if (tipIndex === 1) {
      return t('entries.todaysTips.tip1', language);
    } else if (tipIndex === 2) {
      return t('entries.todaysTips.tip2', language);
    } else {
      return t('entries.todaysTips.tip3', language);
    }
  };
  
  return (
    <Card className={`mb-6 border-dashed border-primary/50 bg-primary/5 transition-all duration-300 hover:shadow-md ${animation ? 'animate-fade-in' : 'opacity-0'}`}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center text-lg font-medium text-primary">
          <Lightbulb className="h-5 w-5 mr-2" />
          {t('entries.todaysTips.title', language)}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm leading-relaxed">{getTodaysTip()}</p>
      </CardContent>
    </Card>
  );
};

export default TipOfTheDay;
